module.exports = __webpack_public_path__ + "img/do---den.9f253ee0.png";